<script setup lang="ts">
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import Backend from '@/models/backend.ts'
import { ref } from 'vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Get the planet data
const gameStore = useGameStore()
const backend = new Backend()

const foodSlider = ref(100)
const scienceSlider = ref(100)
const productionSlider = ref(100)

// Handle form submission
const submit = () => {
  backend
    .updatePlanetPopulation(
      gameStore.modalData,
      foodSlider.value,
      scienceSlider.value,
      productionSlider.value
    )
    .then(() => {
      gameStore.modalType = ''
    })
}
</script>

<template>
  <SmallModel :title="t('modals.populationAssignments.title')">
    <div class="p-2">
      <div class="text-subtext pb-2">
        {{ t('modals.populationAssignments.description') }}
      </div>
      <div class="xl:flex justify-between pl-2 pr-2">
        <div class="flex-1 p-2 flex">
          <img
            class="w-10 h-10 mr-3 rounded-3xl"
            :src="'' + gameStore.cdnUrl + 'images/population/64/food.webp'"
            :alt="t('modals.populationAssignments.farmers')"
            :title="t('modals.populationAssignments.farmers')"
          />
          <div class="relative mb-6 flex-grow">
            <label for="labels-range-input" class="sr-only">Labels range</label>
            <input
              id="population_food"
              min="0"
              max="100"
              step="1"
              v-model="foodSlider"
              type="range"
              class="w-full h-2 rounded-lg appearance-none cursor-pointer bg-gray-700"
            />
            <span class="text-subtext absolute start-0 -bottom-6"
              >{{ t('modals.populationAssignments.farmers') }}: <span class="text-white">{{ foodSlider }}%</span></span
            >
          </div>
        </div>
        <div class="flex-1 p-2 flex">
          <img
            class="w-10 h-10 mr-3 rounded-3xl"
            :src="'' + gameStore.cdnUrl + 'images/population/64/production.webp'"
            :alt="t('modals.populationAssignments.workers')"
            :title="t('modals.populationAssignments.workers')"
          />
          <div class="relative mb-6 flex-grow">
            <label for="labels-range-input" class="sr-only">Labels range</label>
            <input
              id="population_production"
              min="0"
              max="100"
              step="1"
              v-model="productionSlider"
              type="range"
              class="w-full h-2 rounded-lg appearance-none cursor-pointer bg-gray-700"
            />
            <span class="text-subtext absolute start-0 -bottom-6"
              >{{ t('modals.populationAssignments.workers') }}: <span class="text-white">{{ productionSlider }}%</span></span
            >
          </div>
        </div>
        <div class="flex-1 p-2 flex">
          <img
            class="w-10 h-10 mr-3 rounded-3xl"
            :src="'' + gameStore.cdnUrl + 'images/population/64/research.webp'"
            :alt="t('modals.populationAssignments.scientists')"
            :title="t('modals.populationAssignments.scientists')"
          />
          <div class="relative mb-6 flex-grow">
            <label for="labels-range-input" class="sr-only">Labels range</label>
            <input
              id="population_science"
              min="0"
              max="100"
              step="1"
              v-model="scienceSlider"
              type="range"
              class="w-full h-2 rounded-lg appearance-none cursor-pointer bg-gray-700"
            />
            <span class="text-subtext absolute start-0 -bottom-6 whitespace-nowrap"
              >{{ t('modals.populationAssignments.scientists') }}: <span class="text-white">{{ scienceSlider }}%</span></span
            >
          </div>
        </div>
      </div>
      <div class="pt-2 text-center"><ActionButton @click="submit">{{ t('common.actions.submit') }}</ActionButton></div>
    </div>
  </SmallModel>
</template>

<style scoped lang="scss">
select {
  @apply bg-slate-600 p-1 text-slate-400 focus:outline-none;
}
</style>
